import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Icon } from "../../components/ui-kit";
import AskAIPanel from "../../components/AskAIPanel";

export default function AskAIPage() {
  const [topics, setTopics] = useState([]);
  const [topicId, setTopicId] = useState("");
  useEffect(() => {
    api.get("/academics/subjects").then(async ({ data }) => {
      const results = await Promise.all(data.map((s) => api.get(`/academics/subject/${s.id}`).then((r) => r.data)));
      setTopics(results.flatMap((subj) => subj.chapters.flatMap((c) => c.topics.map((t) => ({ id: t.id, name: `${subj.name} · ${t.name}` })))));
    });
  }, []);

  return (
    <div className="max-w-3xl mx-auto p-4 sm:p-6">
      {/* AI hero */}
      <div className="relative rounded-[28px] p-6 text-white overflow-hidden mb-5" style={{ background: "linear-gradient(135deg,#8a6df0,#5f3fd0)" }}>
        <div className="absolute inset-0 dotgrid opacity-50" />
        <Icon name="Sparkles" className="absolute -right-3 -bottom-4 w-32 h-32 opacity-15" />
        <div className="relative flex items-center justify-between gap-4 flex-wrap">
          <div>
            <div className="text-[11px] font-bold uppercase tracking-widest text-white/80">AI Tutor</div>
            <h1 className="text-3xl font-bold mt-1 tracking-tight">Ask Mimi anything</h1>
            <p className="text-white/80 text-sm mt-1">Type or speak — I understand your topic automatically.</p>
          </div>
          <select value={topicId} onChange={(e) => setTopicId(e.target.value)} data-testid="askai-topic-select"
            className="glass text-white text-sm rounded-xl px-4 py-2.5 outline-none border border-white/25 max-w-[220px] [&>option]:text-mim-navy">
            <option value="">General (no topic)</option>
            {topics.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
          </select>
        </div>
      </div>
      <div className="bg-white border border-mim-line rounded-3xl shadow-mim p-4 sm:p-5">
        <AskAIPanel key={topicId} topicId={topicId || null} topicName={topics.find((t) => t.id === topicId)?.name} />
      </div>
    </div>
  );
}
